/**
 * Feature entitlements for delivery software features.
 *
 * These entitlements control access to delivery software features at the retailer level
 * based on business agreements. Only retailers with this entitlement can access
 * partner-managed bulk delivery routes and related features.
 *
 */
export enum FeatureEntitlements {
  PartnerBulkDeliveryEnabled = 'fulfillment.delivery_software.partner_bulk_delivery_enabled',
}
